/**
 * Shared constants for Todo en Local Marketplace
 */

// Brand colors - Professional & Modern
export const COLORS = {
  navyBlue: '#1e3a5f',      // Azul marino profundo - botones, textos importantes
  darkSlate: '#0f172a',     // Slate muy oscuro - headers, fondos oscuros
  orange: '#F37322',        // Naranja - CTA principal, acentos de energía
  lightGray: '#f8fafc',     // Fondo claro
  mediumGray: '#64748b',    // Texto secundario
  white: '#ffffff',
  success: '#22c55e',       // Verde para estados exitosos
  error: '#ef4444',         // Rojo para errores
};

// Default placeholder images for products without photos
export const PLACEHOLDER_IMAGES = {
  product: 'https://images.unsplash.com/photo-1630448926286-0a77c8ba11e4?w=400&h=400&fit=crop&q=80',
  store: 'https://images.unsplash.com/photo-1604719312566-8912e9227c6a?w=400&h=400&fit=crop&q=80',
  category: 'https://images.unsplash.com/photo-1607082348824-0a96f2a4b9da?w=200&h=200&fit=crop&q=80',
};

// Override placeholder images from backend config
export const initPlaceholderImages = (config) => {
  if (config?.product_url) {
    PLACEHOLDER_IMAGES.product = config.product_url;
  }
};

// Get a placeholder image or the actual image
export const getProductImage = (imageUrl) => {
  return imageUrl || PLACEHOLDER_IMAGES.product;
};

export const getStoreImage = (imageUrl) => {
  return imageUrl || PLACEHOLDER_IMAGES.store;
};
